import { replacePlanCode } from '@lib/billing-plan-name';
import { TranslatesFnType } from '@nx-frontend/shared/types';

// Expects global localization scope
export const getPaywallTitle = (subscriptionType: string, t: TranslatesFnType) => {
  let paywallTitle = t('features.paywall.title_upgrade_now');

  switch (subscriptionType) {
    case 'standard':
      paywallTitle = t('features.paywall.title_upgrade_for_seamless');
      break;
    case 'plus':
      paywallTitle = t('features.paywall.title_boost_client_experience');
      break;
    case 'team':
      paywallTitle = t('features.paywall.title_reach_new_heights', {
        planName: replacePlanCode('#business#'),
      });
      break;
    case 'premium':
      paywallTitle = t('features.paywall.title_boost_client_experience');
      break;
    case 'business2023':
      paywallTitle = t('features.paywall.title_upgrade_for_seamless');
      break;
  }

  return paywallTitle;
};
